// extracted by mini-css-extract-plugin
module.exports = {"container":"cms-content_container___VxHu","title-container":"cms-content_title-container__zV6OC"};